import { render } from "./Alarms.vue?vue&type=template&id=8959390e&scoped=true&ts=true"
import script from "./Alarms.vue?vue&type=script&lang=ts"
export * from "./Alarms.vue?vue&type=script&lang=ts"

import "./Alarms.vue?vue&type=style&index=0&id=8959390e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8959390e"]])

export default __exports__